"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StartHeaderType = exports.ImageSizeType = exports.notInlineTypes = exports.markdownColorsVariants = exports.MarkdownSize = exports.MarkdownUnorderedListStyle = void 0;
var MarkdownUnorderedListStyle;
(function (MarkdownUnorderedListStyle) {
  MarkdownUnorderedListStyle["Dot"] = "dot";
  MarkdownUnorderedListStyle["Rhombus"] = "rhombus";
})(MarkdownUnorderedListStyle = exports.MarkdownUnorderedListStyle || (exports.MarkdownUnorderedListStyle = {}));
var MarkdownSize;
(function (MarkdownSize) {
  MarkdownSize["PersonalAreaSmall"] = "personal-area-s";
  MarkdownSize["PersonalAreaMedium"] = "personal-area-m";
  MarkdownSize["Quiz"] = "quiz";
  MarkdownSize["Small"] = "s";
  MarkdownSize["Medium"] = "m";
  MarkdownSize["Large"] = "l";
})(MarkdownSize = exports.MarkdownSize || (exports.MarkdownSize = {}));
exports.markdownColorsVariants = ['white', 'white-link', 'gray', 'blue'];
exports.notInlineTypes = ['root', 'break', 'thematicBreak', 'blockquote', 'delete', 'image', 'linkReference', 'imageReference', 'table', 'tableHead', 'tableBody', 'tableRow', 'tableCell', 'list', 'listItem', 'definition', 'heading', 'code', 'html', 'virtualHtml'];
var ImageSizeType;
(function (ImageSizeType) {
  ImageSizeType["Original"] = "Original";
  ImageSizeType["FullWidth"] = "FullWidth";
})(ImageSizeType = exports.ImageSizeType || (exports.ImageSizeType = {}));
var StartHeaderType;
(function (StartHeaderType) {
  StartHeaderType["auto"] = "auto";
  StartHeaderType["h1"] = "h1";
  StartHeaderType["h2"] = "h2";
  StartHeaderType["h3"] = "h3";
  StartHeaderType["h4"] = "h4";
  StartHeaderType["h5"] = "h5";
  StartHeaderType["h6"] = "h6";
  StartHeaderType["div"] = "div";
  StartHeaderType["span"] = "span";
  StartHeaderType["p"] = "p";
})(StartHeaderType = exports.StartHeaderType || (exports.StartHeaderType = {}));